module.exports = __webpack_public_path__ + "img/chara-head-3.d3c67644.png";